<template>
  <div class="directories__item py-2" :class="paddingClass">
    <div class="directories__item">
      <div class="directories__checkbox">
        <v-checkbox
          v-model="active"
          color="blue-grey lighten-1"
        >
        </v-checkbox>
      </div>
      <div class="directories__icon">
        <v-icon color="primary">
          folder
        </v-icon>
      </div>
      <div class="directories__name">
        {{dir.name}}
      </div>
      <div class="directories__sub pt-2" v-if="subdirectories && subdirectories.length > 0">
        <DirectoriesItem
          v-for="(singleDir, index) in subdirectories"
          :dir="singleDir"
          :parent="dir.id"
          :key="index"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'DirectoriesItem',
  props: ['dir', 'parent'],
  data: () => ({
    busy: false,
  }),
  computed: {
    ...mapGetters('users', [
      'dirAccess',
    ]),
    subdirectories() {
      return this.dir.subdirectories;
    },
    hasAccess() {
      return this.dir.has_access;
    },
    paddingClass() {
      return this.$vuetify.breakpoint.smAndDown ? 'px-3' : 'px-4';
    },
    active: {
      get() {
        return this.dirAccess.includes(this.dir.id);
      },
      set(val) {
        if (val) {
          this.addDirAccess(this.dir.id);
        } else {
          this.removeDirAccess(this.dir.id);
        }
      },
    },
  },
  methods: {
    ...mapActions('users', [
      'addDirAccess',
      'removeDirAccess',
    ]),
    verifyAccess() {
      if (this.hasAccess) {
        this.addDirAccess(this.dir.id);
      }
    },
    activeChildren() {
      this.subdirectories.forEach((sub) => {
        this.addDirAccess(sub.id);
      });
    },
  },
  watch: {
    active(val) {
      if (!val) {
        this.removeDirAccess(this.parent);
      } else {
        this.activeChildren();
      }
    },
    dir: {
      immediate: true,
      handler(val) {
        if (this.hasAccess) {
          this.addDirAccess(val.id);
        }
      },
      deep: true,
    },
  },
};
</script>
